import { render, staticRenderFns } from "./GestionCajas.vue?vue&type=template&id=0f2bce33&scoped=true"
import script from "./GestionCajas.vue?vue&type=script&lang=js"
export * from "./GestionCajas.vue?vue&type=script&lang=js"
import style0 from "./GestionCajas.vue?vue&type=style&index=0&id=0f2bce33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2bce33",
  null
  
)

export default component.exports